import React from 'react';


function Footer() {
  

  return (
  <div className='' style={{paddingBottom:'0px',marginbottom:'0px',color:'white',backgroundColor:'#222222'}}>
  <div class="container">
  <footer class="py-3 my-4 mb-0 pb-0 ">
    <ul class="nav justify-content-center border-bottom pb-3 mb-3">
      <li class="nav-item"><a href="/" class="nav-link px-2 text-white">ACCEUIL</a></li>
      <li class="nav-item"><a href="/services" class="nav-link px-2 text-white">SERVICES</a></li>
      <li class="nav-item"><a href="/projects" class="nav-link px-2 text-white">PROJECTS</a></li>
      <li class="nav-item"><a href="/login" class="nav-link px-2 text-white">CONTACT</a></li>
      <li class="nav-item"><a href="/about" class="nav-link px-2 text-white">QUI SOMME NOUS?</a></li>
    </ul>
    <p class="text-center mb-0 pb-2">ALL RIGHTS RESERVED &copy; 2024 BY M.RGUIG</p>
  </footer>
</div>
    
    </div>
  );
}

export default Footer;
